import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-0"}],["path",{"d":"M8 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-1"}],["path",{"d":"M8 19a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-2"}],["path",{"d":"M14 5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-3"}],["path",{"d":"M14 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-4"}],["path",{"d":"M14 19a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-5"}]]

const IconGripVertical = createReactComponent('outline', 'grip-vertical', 'GripVertical', __iconNode);

export default IconGripVertical;